import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import { addQueueGlobalCount } from '../../../store/emarsys/action';
import { PAGE_NAME_BRANCH_SALES } from '../../../constants/emarsys/branch-sales';

interface Props {
  firstRef: React.RefObject<HTMLElement>;
  pageTitle: string;
  pageName: string;
  breadcrumbItems: IBreadcrumbs[];
  sectionName: string;
  newParams?: Record<string, string | number | boolean>;
  isProvinceReady?: boolean;
}

const useImpressionBranchSales = ({
  firstRef,
  pageTitle,
  pageName,
  breadcrumbItems,
  sectionName,
  newParams,
  isProvinceReady = true,
}: Props) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    (callbackFunction) => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      const isSalesAdvisorPageName = pageName === PAGE_NAME_BRANCH_SALES.SALES_ADVISOR;
      const isBranchSalesActive =
        !isSalesAdvisorPageName && getFlagValue(FLAG_ENUM.EMARSYS_BRANCH_SALES);
      const isBranchSalesAdvisorActive =
        isSalesAdvisorPageName && getFlagValue(FLAG_ENUM.EMARSYS_BRANCH_SALES_SALES_ADVISOR);
      if (
        isAuth &&
        isFlagActive &&
        isProvinceReady &&
        (isBranchSalesActive || isBranchSalesAdvisorActive)
      ) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: pageName ?? '',
          page_title: pageTitle ?? '',
          page_url: window.location.href,
          section_name: sectionName ?? '',
          menu_cat_lvl1: breadcrumbItems?.[1]?.name?.toUpperCase() ?? '',
          ...newParams,
        };

        if (userData) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueGlobalCount());
        callbackFunction();
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth, isProvinceReady],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0,
    true
  );

  return null;
};

export default useImpressionBranchSales;
